<template lang="html">
    <div id="page__costs-zones" class="center-panel">
        <md-content md-theme="white" v-bind:loading="progress">
            <sort-table
                v-bind:columns="tableColumns" v-model="zones" v-on:refresh="getZones" v-bind:per-page="perPage" 
                v-bind:total="zonesAmount" link table-id="zones" ref="table" v-on:create="addZone"
            >
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable from '@/components/SortTable';
    import ZIconButton from '@/components/ZIconButton';
    export default {
        components: { SortTable, ZIconButton },
        data() {
            return {
                perPage: 50,
                tableColumns: [
                    { label: 'ID', field: 'id', default: true, sortable: true },
                    { label: 'Название', field: 'name', sortable: true },
                    //{ label: 'ОКАТО', field: 'okato', sortable: true },
                    //{ label: 'ФИАС', field: 'aoguid', sortable: true },
                    { label: '', field: 'actions' },
                ],
                deleteDialog: false,
                zoneIdToDelete: null
            }
        },
        computed: {
            /**
             * Список зон
             */
            zones() {
                return this.$store.state.cost.zones.map(zone => {
                    zone.routerLink = {name: 'Zone', params: {zoneid: zone.id}, query: this.$route.query};
                    return zone;
                });
            },
            /**
             * Количество зон
             */
            zonesAmount() {
                return this.$store.state.cost.zones_amount
            },
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-costs-zones-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        created() {
            this.$store.commit('setTitle', 'Направления')
        },
        methods: {
            /**
             * Добавление зоны
             */
            addZone() {
                this.$router.push({ name: 'Zone', params: {zoneid: 'new'} });
            },
            /**
             * Получение зон
             */
            getZones(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-costs-zones-list');
                return this.$store.dispatch('cost/getZones', {
                    order_by: orderBy, order_type: orderType, page:  page, count: count, filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'get-costs-zones-list'));
            },
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), result = {model: [], relation: [], condition: 'and'};

                if (filter.search) result.model = [['name', '%', filter.search]];

                return result;
            },
            /**
             * Удаление зоны
             */
            removeZone(id) {
                this.$store.commit('showProgressBar', 'get-costs-zones-list');
                this.$store.dispatch('cost/deleteZone', id)
                    .then(() => this.$root.$emit('refresh-table', 'zones'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-costs-zones-list'));
            },
            /**
             * Модальное окно с удалением зоны
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении группы', 'Действие необратимо!',
                    () => this.removeZone(id)
                );
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Zones.vue?747f1a4f